import React from "react";
import PropTypes from "prop-types";
import { EntityTypes } from "../../../utils/constants";

/*  Link Entity strategies and components */

// find link entities in a content block
export function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === EntityTypes.LINK;
  }, callback);
}

export const LinkComponent = (props) => {
  const handleClick = () => {
    props.focusLink(props.blockKey, props.start);
  };
  const entityData = props.contentState.getEntity(props.entityKey).get("data");

  // To preserve styles on ansers we need to detect the styles on the first child and apply them to the parent
  const styleSet = props.children[0].props.styleSet.toJS();
  const styleObject = createStylesFromStyleSet(styleSet);

  return (
    <span
      title={entityData.text}
      className="link"
      contentEditable={true}
      readOnly
      onClick={handleClick}
      suppressContentEditableWarning
      style={styleObject}
    >
      {props.children}
    </span>
  );
};

LinkComponent.propTypes = {
  children: PropTypes.node,
  blockKey: PropTypes.string,
  start: PropTypes.number,
  entityKey: PropTypes.string,
  focusLink: PropTypes.func,
  contentState: PropTypes.shape({
    getEntity: PropTypes.func,
  }),
};

function createStylesFromStyleSet(styleSet) {
  let styleObject = {};

  styleSet.forEach((styleKeyword) => {
    switch (styleKeyword) {
      case "BOLD":
        styleObject.fontWeight = "bold";
        break;
      case "ITALIC":
        styleObject.fontStyle = "italic";
        break;
      case "UNDERLINE":
        styleObject.textDecoration = "underline";
        break;
      default:
        break;
    }
  });

  return styleObject;
}
